import React, { Component, useCallback } from "react";
import styles from "./reportContructor.module.scss";
import { withReportsList } from "../../../shared/containers/containerReportsList";
import { withCustomReport } from "../../../shared/containers/containerCustomReport";
import { states } from "../../../reducers/queriesStates";
import { v4 as uuidv4 } from "uuid";
import ReportCharFieldsConstructorItem from "./ReportCharFieldsConstructorItem";
import ReportChartAxisConstructorToolpanel from "./ReportChartAxisConstructorToolpanel";

class ReportChartFieldsConstructor extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedField: null,

      shiftField: null,
      key: uuidv4(),
    };
  }

  componentDidUpdate(prevProps) {
    const { shiftCustomReportFieldDataState } = this.props;

    if (this.isUnselect(prevProps)) {
      this.setState({ selectedField: null, key: uuidv4() });
    }

    if (prevProps.shiftCustomReportFieldDataState === states.REQUEST && shiftCustomReportFieldDataState === states.READY) {
      const { shiftField } = this.state;
      this.onSelectToChange(shiftField);
    }
  }

  isUnselect(prevProps) {
    const { updateCustomReportFieldDataState, addCustomReportFieldDataState, deleteCustomReportFieldDataState, updateCustomReportAxisDataState } = this.props;

    return (
      (prevProps.updateCustomReportFieldDataState === states.REQUEST && updateCustomReportFieldDataState === states.READY) ||
      (prevProps.updateCustomReportAxisDataState === states.REQUEST && updateCustomReportAxisDataState === states.READY) ||
      (prevProps.addCustomReportFieldDataState === states.REQUEST && addCustomReportFieldDataState === states.READY) ||
      (prevProps.deleteCustomReportFieldDataState === states.REQUEST && deleteCustomReportFieldDataState === states.READY)
    );
  }

  onSelectToChange(field) {
    const { selectedField } = this.state;

    if (selectedField === null || selectedField.id !== field.id) {
      this.setState({
        selectedField: field,
        shiftField: null,
      });
    }

    this.setState({ key: uuidv4() });
  }

  onChangeTitle(title) {
    const { selectedField } = this.state;

    if (selectedField !== null) {
      selectedField.dashboard.title = title;
      this.setState({ selectedField: selectedField, key: uuidv4() });
    }
  }

  onUpdateField() {
    const { onUpdateCustomReportField, selectedCustomReportId } = this.props;
    const { selectedField } = this.state;

    if (selectedField !== null) {
      const options = {
        id: selectedField.id,
        title: selectedField.dashboard.title,
        excelColumnWidth: selectedField.excelColumnWidth,
        cssColumnWidth: selectedField.cssColumnWidth,
      };

      onUpdateCustomReportField(options, selectedCustomReportId);
    }
  }

  onUpdateAxis() {
    const { onUpdateCustomReportField, selectedCustomReportId } = this.props;
    const { selectedField } = this.state;

    if (selectedField !== null) {
    }
  }

  getAxisControl(field) {
    const { selectedField } = this.state;
    const isSelect = selectedField !== null && selectedField.id === field.id;

    return (
      <ReportCharFieldsConstructorItem key={uuidv4()} field={field} onSelectHandle={this.onSelectToChange.bind(this)} isSelect={isSelect} />
    );
  }

  render() {
    const { fields } = this.props;
    const { selectedField, key } = this.state;

    return (
      <div key={key}>
        <div>Панель параметров:</div>

        <div style={{ display: "flex" }}>
          <div className={styles.dashboardsChartItemsContainer}>
            {fields
              .filter((x) => {
                return x.chartAxis.type !== 2;
              })
              .map((x) => {
                return this.getAxisControl(x);
              })}
          </div>

          <div>
            <ReportChartAxisConstructorToolpanel field={selectedField} />
        
          </div>
        </div>
      </div>
    );
  }
}

export default withCustomReport(withReportsList(React.memo(ReportChartFieldsConstructor)));
